module.exports = __webpack_public_path__ + "static/media/DSC_0100.2924cfa8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/scenery/DSC_0100.jpg
// module id = 688
// module chunks = 0